module.exports = "<select [id]=\"this.element\" class=\"form-control select2\" [class.is-invalid]=\"error\" [disabled]=\"disabled\"></select>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/tools/select2/select2-multi-groups/select2-multi-groups.component.html
// module id = ./src/app/components/tools/select2/select2-multi-groups/select2-multi-groups.component.html
// module chunks = main